import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

import ImportFacultyModal from "./partials/ImportFacultyModal";

import {
    getFaculties as onGetFaculties,
    addNewFaculty as onAddNewFaculty,
    updateFaculty as onUpdateFaculty,
    deleteFaculty as onDeleteFaculty,
} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const Faculty = () => {

    //meta title
    document.title = "Facultés | CinzanEdu";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [faculty, setFaculty] = useState(null);

    const [modalOpen, setModalOpen] = useState(false);
    


 

    // validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            id: (faculty && faculty.id) || '',
            uid: (faculty && faculty.uid) || '',
            name: (faculty && faculty.name) || '',
            code: (faculty && faculty.code) || '',
            description: (faculty && faculty.description) || '',
            is_active: (faculty && faculty.is_active) || '',
            
        },
        validationSchema: Yup.object({
           
            name: Yup.string().required("Veuillez saisir le nom"),
            //code: Yup.string().required("Veuillez saisir le code"),
            //series_category_id: Yup.string().required("Veuillez sélectionner la catégorie"),
            
  
        }),
        onSubmit: (values) => {
            if (isEdit) {
                //const payload = { series_category: values }
                const updateFaculty = {
                    id: values.id,
                    uid: values.uid,
                    name: values.name,
                    code: values.code,
                    description: values.description,
                    is_active: values.is_active,
                    
                };
                // update movie category
                dispatch(onUpdateFaculty(updateFaculty));
                validation.resetForm();
            } else {
                const newFaculty = {
                    //id: values["id"],
                    //uid: values["uid"],
                    name: values["name"],
                    code: values["code"],
                    description: values["description"],
                    is_active: values["is_active"],
                   
                };
                // save new movie category
                dispatch(onAddNewFaculty(newFaculty));
                validation.resetForm();
            }
            toggle();
        },
    });

    const dispatch = useDispatch();

    const FacultyProperties = createSelector(
        (state) => state.facultyReducer, // C’est une fonction qui prend tout le state Redux et renvoie seulement la partie SerialMovieReducer
        (facultyReducer) => ({
            faculties: facultyReducer.faculties,
            loading: facultyReducer.loading
        })
    );

    const {faculties, loading} = useSelector(FacultyProperties);

    const [isLoading, setLoading] = useState(loading)

    useEffect(() => {

       
        if (faculties && !faculties.length) {
            console.log("ON L")
            dispatch(onGetFaculties());
        }
    }, [dispatch, faculties]);

    const toggle = () => {
        if (modal) {
            setModal(false);
            setFaculty(null);
        } else {
            setModal(true);
        }
    };

    const handleFacultyClick = arg => {
        const faculty = arg;
        setFaculty({
            id: faculty.id,
            uid: faculty.uid,
            name: faculty.name,
            code: faculty.code,
            description: faculty.description,
            is_active: faculty.code,
           
        });


        // Set for update url
        setIsEdit(true);

        toggle();
    };

    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (branch) => {
        setFaculty(branch);
        setDeleteModal(true);
    };

    const handleDeleteFaculty = () => {
        if (faculty && faculty.id) {
            //dispatch(onDeleteSerialeventCategory(serialeventCategory.id));
            dispatch(onDeleteFaculty(faculty));
            setDeleteModal(false);
        }
    };

    const onClickNewFaculty = () => {
        setIsEdit(false);
        setFaculty(null);
        toggle();
        //setModal(true)
    };

    const handleSuccess = (data) => {
        console.log("Import réussi :", data);
        // ici tu peux recharger la liste des facultés si besoin
    };

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Nom",
                accessorKey: "name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Code",
                accessorKey: "code",
                enableColumnFilter: false,
                enableSorting: true,
            },
            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleFacultyClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteFaculty}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Facultés" breadcrumbItem="Liste des facultés" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="d-flex gap-2">
                                                    <Button color="success" onClick={() => setModalOpen(true)}>
                                                        Importer un fichier
                                                    </Button>

                                                    <Link to="#!" onClick={onClickNewFaculty} className="btn btn-primary me-1">Ajouter une faculté</Link>
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={faculties || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                    <Modal 
                        isOpen={modal} 
                        toggle={toggle}
                         backdrop={'static'}
                            id="staticBackdrop"
                    >
                        <ModalHeader toggle={toggle} tag="h4">
                            {!!isEdit ? "Modifier - Faculté" : "Ajouter - Faculté"}
                        </ModalHeader>
                        <ModalBody>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row>
                                    <Col className="col-12">
                                        
                                        <div className="mb-3">
                                            <Label>Nom</Label>
                                            <Input
                                                name="name"
                                                type="text"
                                                placeholder="Nom"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.name || ""}
                                                invalid={
                                                    validation.touched.name && validation.errors.name ? true : false
                                                }
                                            />
                                            {validation.touched.name && validation.errors.name ? (
                                                <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Code</Label>
                                            <Input
                                                name="code"
                                                type="text"
                                                placeholder="Code"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.code || ""}
                                                invalid={
                                                    validation.touched.code && validation.errors.code ? true : false
                                                }
                                            />
                                            {validation.touched.code && validation.errors.code ? (
                                                <FormFeedback type="invalid">{validation.errors.code}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Description</Label>
                                            <Input
                                                name="description"
                                                placeholder="Description"
                                                type="textarea"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.description || ""}
                                                invalid={
                                                    validation.touched.description && validation.errors.description ? true : false
                                                }
                                            />
                                            {validation.touched.description && validation.errors.description ? (
                                                <FormFeedback type="invalid">{validation.errors.description}</FormFeedback>
                                            ) : null}
                                        </div>

                                        
                                       
                                        
                                       

                                        

                                        
                                        
                                        
                                        
                                        
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="text-end">
                                            <Button color="btn btn-primary me-1"
                                                type="submit"
                                                className="save-user"
                                            >
                                                
                                                {!!isEdit ? "Modifier " : "Enregistrer"}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
            <ToastContainer />

            <ImportFacultyModal
                isOpen={modalOpen}
                toggle={() => setModalOpen(!modalOpen)}
                onSuccess={handleSuccess}
            />


        </React.Fragment>
    );
}


export default Faculty;